import React, { useState } from 'react';
import { InputNumber as AntInputNumber } from 'antd';
import styled from 'styled-components';

const StyledInputNumber = styled(AntInputNumber)`
  width: 100%;

  input::placeholder {
    font-style: italic;
  }

  &.ant-input-number-affix-wrapper {
    width: 100%;

    .ant-input-number-suffix {
      color: var(--greyscale-shade);
    }
  }

  &.ant-input-number-disabled,
  &.ant-input-number-disabled input[disabled] {
    border-color: var(--greyscale-dark-white);
    cursor: default;

    input::placeholder {
      color: var(--greyscale-concrete);
    }

    &:hover:not([disabled]) {
      border-color: var(--greyscale-dark-white);
    }
  }

  &.ant-input-number-status-error:not(.ant-input-number-disabled) {
    .ant-input-number-prefix {
      color: var(--greyscale-blackish);
    }

    .ant-input-number-suffix {
      color: var(--greyscale-shade);
    }
  }
`;

const InputNumber = ({ controls = false, inputMode = 'text', ...props }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <StyledInputNumber
      controls={controls}
      inputMode={inputMode}
      {...props}
      className={isFocused ? 'has-focus' : ''}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};

export default InputNumber;
